<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="12"
      >
        <v-alert
          type="warning"
          dense
          colored-border
          border="top"
          dismissible
        >
          Sollte die Leitstelle z.B. im Fall einer Unwetterlage telefonisch und über Funk trotz mehrerer Versuche anhaltend nicht erreichbar sein, kann die ELO nach vorheriger
          Rücksprache mit dem BvD selbst eine Notalarmierung der aPager-Apps über ein Notalarmierungs-Tableau durchführen.
        </v-alert>
      </v-col>
      <v-col
        cols="3"
      >
        <v-card
        >
          <v-card-title>
            Einheiten
          </v-card-title>
          <v-card-subtitle>
            Wähle die zu alarmierenden Einheiten
          </v-card-subtitle>
          <v-card-text>
            <v-list>
              <v-list-item-group
                v-model="selected"
                multiple
                color="primary"
              >
                <v-list-item
                  v-for="(item, i) in items"
                  :key="i"
                  :disabled="state != 0"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title> {{ item.name }} </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-checkbox
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="6"
      >
        <v-card>
          <v-card-title>
            Meldung
            <v-spacer></v-spacer>
            <v-btn
              small
              color="secondary"
              @click="reset"
            >
              Reset
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container
              fluid
            >
              <v-row>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="alarm.keyword"
                    label="Stichwort"
                    filled
                    dense
                    hide-details
                    :disabled="state != 0"
                  ></v-text-field>
                </v-col>
                <!---
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="alarm.keyword_description"
                    label="Alarmmeldung"
                    filled
                    dense
                    hide-details
                    :disabled="state != 0"
                  ></v-text-field>
                </v-col> --->
                <v-col
                  v-if="getDummyText.length > 0"
                  cols="12"
                >
                  <v-textarea
                    v-model="alarm.text"
                    filled
                    shaped
                    label="Nachricht"
                    dense
                    hide-details
                    no-resize
                    disabled
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="3"
      >
        <v-card
        >
          <v-card-title>
            Überprüfen
          </v-card-title>
          <v-card-text>
            <div
              class="mb-1"
            >
              Ausgewälte Einheiten ({{selected.length}}):
            </div>
            <v-alert
              v-for="index in selected"
              :key="index"
              type="error"
              dense
            >{{ items[index].name }}</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="success"
              :disabled="state != 0 || selected.length == 0"
              @click="state = 1"
            >
              Überprüft
            </v-btn>
            <v-btn
              class="primary"
              :disabled="state != 1"
              @click="send_alarm"
            >
              Alarmieren
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotalarmView",
  data: () => ({
    selected: [],
    alarm: {
      keyword: "",
      keyword_description: "Notalarm",
      text: "Wache besetzen. 10-09-1 ansprechen."
    },
    items: [
      {
        name: 'Notalarm_Berenbostel',
      },
      {
        name: 'Notalarm_Frielingen',
      },
      {
        name: 'Notalarm_Garbsen',
      },
      {
        name: 'Notalarm_Heitlingen',
      },
      {
        name: 'Notalarm_Horst',
      },
      {
        name: 'Notalarm_Meyenfeld',
      },
      {
        name: 'Notalarm_Osterwald_Oberende',
      },
      {
        name: 'Notalarm_Osterwald_Unterende',
      },
      {
        name: 'Notalarm_Schloss_Ricklingen',
      },
      {
        name: 'Notalarm_Stelingen',
      },
      {
        name: 'Notalarm_Z_BvD',
      },
      {
        name: 'Notalarm_Z_Funkwart',
      },
      {
        name: 'Notalarm_Z_Ltr_ELO',
      }
    ],
    state: 0
  }),
  computed: {
    getDummyText() {
      if(this.alarm.keyword === 'ntuw'){
        return 'Notalarm / Wache besetzen. 10-09-1 ansprechen.'
      }
      return ''
    }
  },
  methods: {
    send_alarm(){
      if(this.alarm.keyword, this.alarm.keyword_description, this.alarm.text){
        let url = "/alarm"
        for(let index in this.selected){
          let unit = this.items[this.selected[index]].name
          let temp_url = url + "/" + unit + "?keyword=" + this.alarm.keyword + "&keyword_description=" + this.alarm.keyword_description + "&text=" + this.alarm.text + " 123456*"
          this.$store.dispatch("update", { "payload_type": "POST", "context": temp_url })
        }
      }
      this.reset()
    },
    reset(){
      this.state = 0
      this.selected = []
      this.alarm.keyword = "ntuw"
      this.alarm.keyword_description = "Notalarm",
      this.alarm.text = "Wache besetzen. 10-09-1 ansprechen."
    }
  },
  mounted() {
    this.reset()
  }
};
</script>

<style scoped>

</style>
